module.exports = __webpack_public_path__ + "img/slipSample.88a772f9.jpg";